import React, { useEffect, useState } from 'react';
import * as RO from './Javascript/ReportObjects';
import * as G from './Javascript/General';
import { convertCoordinates, waypoints_only} from './Javascript/CustomiseReport';
import './CSS/style.css';

const normaliseAreaType = (value: string | null | undefined) => {
	if (typeof value !== "string") return "";
	return value.trim().toLowerCase();
};

interface Props {
  type: string;
  table_title: string;
  areaTimeline: RO.AreaTimeline[];
  timeline_start: Date | null;
  timeline_end: Date | null;
  areaTimelineReport: boolean;
  areaTimelineSummary: boolean;
  positionGranularity: string;
}
const change_coord_format = (value: string) => {
    convertCoordinates(value);
};

const AreaTable: React.FC<Props> = ({ areaTimeline, type, table_title, timeline_start, timeline_end, areaTimelineReport, areaTimelineSummary, positionGranularity = ""}) => {
    const [is_loading, set_is_loading] = useState(true);
    const [areaData, setAreaData] = useState<RO.AreaTimeline[] | null>(null);
    const [tableTitle, setTableTitle] = useState<string>("")
    const [summaryArray, setSummaryArray] = useState<RO.AreaSummary[]>([]);
   useEffect(() => {
       const fetchData = async () => {
           try {
               setTableTitle(table_title);
               const normalisedType = normaliseAreaType(type);

               const filteredAreaData = areaTimeline.filter(
                   i => normaliseAreaType(i.area_type) === normalisedType
               );

               if (filteredAreaData.length > 0) {
                   setAreaData(filteredAreaData);
               } else if (timeline_start && timeline_end) {
                   const timespan = timeline_end.getTime() - timeline_start.getTime();

                   const defaultEntry: RO.AreaTimeline = {
                       area_name: `No ${table_title}`,
                       start: timeline_start.toISOString(),
                       end: timeline_end.toISOString(),
                       leg_hours: Math.floor(timespan / (1000 * 60 * 60)),
                       journey_perc: 100,
                       area_type: ""
                   };

                   setAreaData([defaultEntry]);
               }
           } catch (error) {
               console.error("Error in fetchData:", error);
           }
       };

       fetchData();
   }, [areaTimeline, type, table_title]);


   useEffect(() => {
        if (areaData) {
           const summarizedData = areaData.reduce<{ [key: string]: { total_hours: number; total_journey_perc: number } }>((acc, item) => {
               const name = item.area_name;
               if (!acc[name]) {
                   acc[name] = { total_hours: 0, total_journey_perc: 0 };
               }
               acc[name].total_hours += parseFloat(String(item.leg_hours || 0));
               acc[name].total_journey_perc += parseFloat(String(item.journey_perc || 0));
               return acc;
           }, {});

           const summaryArray = Object.entries(summarizedData).map(([area_name, values]) => ({
               area_name,
               total_hours: values.total_hours,
               total_journey_perc: values.total_journey_perc,
           }));

           setSummaryArray(summaryArray);
       }
   }, [areaData]);

    return (
    <>
        {areaTimelineReport ? (
            <div className="report_row area_report_table">
                <div className="inner_padding">

                    <p className="sub_title">{tableTitle + " Report"}</p>

                    <table key={type + "_table"} className="area_table">
                        <thead>
                            <tr>
                                <th style={{ width: '30%'}}>Name</th>
                                <th style={{ width: '20%'}}>Entry Date</th>
                                <th style={{ width: '20%'}}>Exit Date</th>
                                <th style={{ width: '10%'}}>Hours</th>
                                <th style={{ width: '20%'}}>Percentage of Journey</th>
                            </tr>
                        </thead>
                        <tbody>
                        {areaData && areaData.map((item: any, index) => (
                            <tr key={type + index}>
                                <td>{G.displayValue(item?.area_name)}</td>
                                <td>{positionGranularity == "d" ? G.displayValue(item?.start.split('T')[0]) : G.displayValue(item?.start.replace("T", " ").split(':').slice(0, 2).join(':'))}</td>
                                <td>{positionGranularity == "d" ? G.displayValue(item?.end.split('T')[0]) : G.displayValue(item?.end.replace("T", " ").split(':').slice(0, 2).join(':'))}</td>
                                <td>{G.displayValue(item?.leg_hours)}</td>
                                <td>{G.displayValue(Math.round(item?.journey_perc * 100) / 100)}%</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        ) : null}
        {areaTimelineSummary && summaryArray.length > 0 && summaryArray[0].area_name.toUpperCase() != "NO "+ tableTitle.toUpperCase() ? (
            <div className="report_row area_report_table">
                <div className="inner_padding">

                    <p className="sub_title">{tableTitle + " Report Summary"}</p>

                    <table key={type + "_table"} className="area_table">
                        <thead>
                            <tr>
                                <th style={{ width: '50%'}}>Name</th>
                                <th style={{ width: '20%'}}>Total Hours</th>
                                <th style={{ width: '30%'}}>Percentage of Journey</th>
                            </tr>
                        </thead>
                        <tbody>
                        {summaryArray.map((item:any, index:number) => (
                            <tr key={index}>
                                <td>{G.displayValue(item.area_name)}</td>
                                <td>{G.displayValue(item.total_hours)}</td>
                                <td>{G.displayValue((Math.round(item?.total_journey_perc * 100) / 100))}%</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        ) : null}
    </>
    );
};
export default AreaTable;
